const ChevronLeftBold = ({
  fill = "white",
  isDisabled,
}: {
  fill?: string
  isDisabled?: boolean
}) => {
  const fillColor = isDisabled ? "var(--color-disable)" : fill
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="20"
      viewBox="0 0 12 20"
      fill="none"
    >
      <path
        d="M0 10C0 10.1765 0.0294117 10.3235 0.0882352 10.4412C0.147059 10.5882 0.235294 10.7059 0.352941 10.8235L9.23529 19.6471C9.47059 19.8824 9.73529 20 10.0882 20C10.4118 20 10.7059 19.8824 10.9412 19.6765C11.1765 19.4412 11.2647 19.1765 11.2647 18.8235C11.2647 18.5 11.1471 18.2353 10.9118 17.9706L2.88235 10L10.9118 2.02941C11.1471 1.79412 11.2647 1.5 11.2647 1.17647C11.2647 0.852941 11.1471 0.558825 10.9412 0.323531C10.7059 0.0882371 10.4412 0 10.0882 0C9.76471 0 9.47059 0.117648 9.23529 0.352943L0.352941 9.17647C0.117647 9.41177 0 9.67647 0 10Z"
        fill={fillColor}
        fillOpacity={fillColor === "white" ? "0.8" : "1"}
      />
    </svg>
  )
}

export default ChevronLeftBold
